import { createLegacyIssueInteraction } from './createLegacyIssueInteraction.tsx';

export const legacyIssueCreateTransitionInteraction: ReturnType<
	typeof createLegacyIssueInteraction
> = createLegacyIssueInteraction('legacy-issue-create.transition');
